import Axios from 'axios'
import { ForbiddenError, NetworkError, UnauthorizedError } from './Errors'
import { requestWrapper } from './requestWrapper'
import { getJwt } from './TokenClient'
import { Entitlement } from '../types/types'

const ENTITLEMENT_API = process.env.NEXT_PUBLIC_ENTITLEMENT_API_URL

const entitlementApiAxios = Axios.create({
  baseURL: ENTITLEMENT_API,
  withCredentials: true,
})

entitlementApiAxios.interceptors.response.use(
  function (response) {
    return response
  },
  async function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if (!error.response) {
      throw new NetworkError(error.message)
    }

    if (error.response.status === 401) {
      throw new UnauthorizedError()
    }
    if (error.response.status === 403) {
      throw new ForbiddenError()
    }

    return Promise.reject(new Error(error.response.data.message))
  }
)

type PostUnlockRequestType = {
  hardwareId: string
  email: string
  username: string
}

export const postUnlockRequest = requestWrapper(
  async ({ hardwareId, email, username }: PostUnlockRequestType) => {
    const reqBody = { email, username }
    await entitlementApiAxios.post(
      `/entitlement/api/claims/request-unlock/${hardwareId}`,
      reqBody,
      {
        headers: { Authorization: `Bearer ${getJwt().accessToken}` },
      }
    )
  }
)

export const getEntitlementClaims = requestWrapper<Entitlement[]>(async () => {
  return (
    await entitlementApiAxios.get('/entitlement/api/claims', {
      headers: { Authorization: `Bearer ${getJwt().accessToken}` },
    })
  ).data
})
